import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { Button, Modal, WhiteButton } from 'components';
import { Dispatch } from 'redux';
import { IStore } from 'redux/IStore';
import { reduxForm } from 'redux-form';
import { InjectedFormProps, ITranslateProps } from 'models/common';
import { ButtonsSection, PortalPageSection } from 'components/PortalStructure';
import { closeModal } from 'redux/modules/modal';
import { IBookingTimeTableForm } from 'models/shop/bookingtimetables';
import { WorkDayPeriods } from '../WorkDayPeriods';
import {
	IEditDayWorkTimeOwnProps,
	dayMinMaxTime,
	officeMinMaxTime,
	stateToEditDailyWorkTimeProps,
	submitForm,
} from '../helpers';
import renderIcon from 'helpers/renderIcon';

type IProps = IEditDayWorkTimeOwnProps &
	ReturnType<typeof stateToEditDailyWorkTimeProps> &
	ReturnType<typeof dispatchToProps> &
	ITranslateProps &
	InjectedFormProps<IBookingTimeTableForm>;

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class EditDayWorkTimeComponent extends React.Component<IProps> {
	public constructor(props: IProps) {
		super(props);

		this.submit = this.submit.bind(this);
	}

	private get canSubmit(): boolean {
		if (this.props.isFetching) {
			return false;
		}
		return true;
	}

	private submit(form: IBookingTimeTableForm) {
		if (!this.canSubmit) {
			return;
		}
		this.props.submitForm(() => this.props.state, this.props.t, form);
	}

	public render() {
		const { t, day, monday, handleSubmit, office, resource } = this.props;
		const limits = dayMinMaxTime(office, monday, day);
		const initialLimits = officeMinMaxTime(office, monday, day);
		const date = monday.clone().add(day, 'days');
		const msDay = day === 6 ? 0 : day + 1; // ISO to Microsoft
		const title = (
			<h1 className="dailyWorkTime__title">
				<strong>{t('Day_' + msDay)}</strong> {date.format('LL')}
			</h1>
		);
		const subtitle = <p className="dailyWorkTime__subtitle">{t('Shop_WorkTime_Editing_Day')}</p>;
		const timezone = office?.zoneInfo;

		return (
			<Modal size="medium" modalClass="modal-with-form dailyWorkTime">
				<div className="dailyWorkTime__headerContainer">
					<div>
						{title}
						{subtitle}
					</div>

					<div>
						<div className="dailyWorkTime__closeButton" onClick={this.props.closeModal}>
							{renderIcon('cancel', 24, 24)}
						</div>
					</div>
				</div>

				<div className="dailyWorkTime__resourceContainer">
					<img
						className="dailyWorkTime__picture"
						src={resource?.picture ? resource.picture : require('containers/Html/icons/pfp_default.svg')}
					/>

					<div className="dailyWorkTime__nameTitle">
						<span>{resource.name}</span>
						<span>{resource.jobTitle}</span>
					</div>
				</div>

				<form onSubmit={handleSubmit(this.submit)}>
					<PortalPageSection variant="contents">
						<WorkDayPeriods
							rootKey={String(day)}
							minTime={limits[0]}
							maxTime={limits[1]}
							initialMinTime={initialLimits[0]}
							initialMaxTime={initialLimits[1]}
							array={this.props.array}
							submitting={this.props.submitting}
							change={this.props.change}
							timezone={timezone}
						/>

						<ButtonsSection align="right">
							<WhiteButton onClick={this.props.closeModal}>{t('BSPortal_Common_Cancel')}</WhiteButton>
							<Button type="submit" disabled={!this.canSubmit}>
								{t('BSPortal_Common_Save')}
							</Button>
						</ButtonsSection>
					</PortalPageSection>
				</form>
			</Modal>
		);
	}
}

let EditDayWorkTime = reduxForm(
	{
		form: c.FORM_NAME_WORK_TIME,
		enableReinitialize: true,
	},
	stateToEditDailyWorkTimeProps,
)(EditDayWorkTimeComponent);

const dispatchToProps = (dispatch: Dispatch<IStore>, ownProps: IEditDayWorkTimeOwnProps) => ({
	submitForm: (getState: () => IStore, t, form: IBookingTimeTableForm) =>
		submitForm(getState, dispatch, t, 'day', ownProps, form),
	closeModal: () => dispatch(closeModal()),
});

EditDayWorkTime = connect(stateToEditDailyWorkTimeProps, dispatchToProps)(EditDayWorkTime);

export { EditDayWorkTime };
